if ( typeof ImageHotspots !== 'function' ) {

  class ImageHotspots extends HTMLElement {

    constructor(){
			
      super();

      this.daysEl = this.querySelector('.days');
			this.zIndex = 9;
			      
      this.hotspots = this.querySelectorAll(
				".image-hotspots__spot--bullet"
			);
			let previoushotspot = null;
            let mouse_on_content = false;

			this.hotspots.forEach((hotspot) => {
				hotspot.addEventListener("mouseover", (event) => {
					if (previoushotspot && previoushotspot !== event.target) {
						previoushotspot.classList.remove("active");
					}
                    if(!event.target.classList.contains("active")){
                      event.target.classList.add("active");
                    }
                  // event.target.classList.toggle("active");
					event.target.parentNode.style.zIndex = this.zIndex++;
					previoushotspot = event.target;
					event.stopPropagation();
				});
                hotspot.addEventListener("mouseleave",(event)=>{
                  event.target.nextElementSibling.addEventListener('mouseenter',(event_)=>{
                    mouse_on_content = true;
                })
                  event.target.nextElementSibling.addEventListener('mouseleave',(event_)=>{
                    mouse_on_content = false;
                    event.target.classList.remove("active");
                })
                  setTimeout(()=>
                  {if(mouse_on_content == false){
      				this.hotspots.forEach((hotspot) => {
                      hotspot.classList.remove("active");
    			});
				previoushotspot = null;
              }
              },200)
                  
              })
			});
            

    }

  }

  if ( typeof customElements.get('image-hotspots') == 'undefined' ) {
    customElements.define('image-hotspots', ImageHotspots);
  }

}

if ( Shopify.designMode ) {
	document.addEventListener("shopify:block:select", (e) => {
		const block = e.target;
		if ( block.classList.contains("image-hotspots__spot--bullet") ) {
			const bulletElements = document.querySelectorAll(
				".image-hotspots__spot--bullet"
			);
			bulletElements.forEach((bulletElement) => {
				bulletElement.classList.remove("active");
			});
			const activeBullet = block.querySelector('.image-hotspots__spot--bullet');
			activeBullet.classList.add('active');
		}
	})
}